import mutations from './mutations';
import actions from './actions';
import getters from './getters';
const Notif = {
    namespaced: true,
    state : {
        total : 0,
        notif : [
            
        ]
    },
    mutations,
    actions,
    getters
}

export default Notif;